import { useEffect, useState } from "react";

export default function useCancellationRequest() {
  const [abortController] = useState(new AbortController());

  useEffect(
    () => () => {
      abortController.abort();
    },
    []
  );

  return { abortController };
}
